import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const DeleteStablishmentApiImpl = async (id: string): Promise<Either<ErrorEntity, void>> => {
    try {
        const relativeUrl: string = `/stablishments/${id}`;
        await di.get<HostApi>(HostApiName).remove(relativeUrl);
        return right(undefined);
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default DeleteStablishmentApiImpl;